import { render, staticRenderFns } from "./PosterEditor.vue?vue&type=template&id=5b41b7d5&scoped=true&"
import script from "./PosterEditor.vue?vue&type=script&lang=js&"
export * from "./PosterEditor.vue?vue&type=script&lang=js&"
import style0 from "./PosterEditor.vue?vue&type=style&index=0&id=5b41b7d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b41b7d5",
  null
  
)

export default component.exports